import ErrorPage from './_error';

export default function Custom429() {
  return <ErrorPage statusCode={429} />;
}
